import React from 'react';
import { xIcon } from '@workday/canvas-system-icons-web';
import { createSubcomponent } from '@workday/canvas-kit-react/common';
import { TertiaryButton } from '@workday/canvas-kit-react/button';
import { space } from '@workday/canvas-kit-react/tokens';
import { usePopupCloseButton, usePopupModel } from './hooks';
export const PopupCloseIcon = createSubcomponent('button')({
    displayName: 'Popup.CloseIcon',
    modelHook: usePopupModel,
    elemPropsHook: usePopupCloseButton,
})(({ children, ...elemProps }, Element) => {
    return (React.createElement(TertiaryButton, Object.assign({ as: Element, size: "medium", icon: xIcon, type: "button", position: "absolute", right: space.xxxs, top: space.xxxs }, elemProps)));
});
